import { CrownTargetModel } from './../../shared/models/crown-target';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardConfig, THEME, NgWizardService, StepChangedArgs, StepValidationArgs } from 'ng-wizard';
import { of } from 'rxjs';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { FrequencyProvider } from '../../shared/providers/frequency.provider';
import { GeographyProvider } from '../../shared/providers/geography.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { RolesProvider } from '../../shared/providers/roles.provider';
import { TargetAchievementProvider } from '../../shared/providers/target-achivement.provider';
import { UnitsProvider } from '../../shared/providers/units.provider';
import { FrequencyModel } from '../../shared/models/frequency';


@Component({
  selector: 'app-add-crown-target',
  templateUrl: './add-crown-target.component.html',
  styleUrls: ['./add-crown-target.component.scss']
})
export class AddCrownTargetComponent implements OnInit {


  frequency: FrequencyModel[];
  headerText: any = "";
  searchText: string = "";
  submittedLevels: any = { isSubmitted: false, state: "engagement" };
  config: NgWizardConfig = {
    selected: 0,
    anchorSettings: { anchorClickable: true, enableAllAnchors: true },
    theme: THEME.default,
    toolbarSettings: {
      toolbarExtraButtons: [],
    },
  };
  submitted = false;
  addForm: FormGroup;
  @Input() targetModel: CrownTargetModel = new CrownTargetModel();
  private _parameters: any;
  targetId: number;
  constructor(
    public targetAchivementProvider: TargetAchievementProvider,
    public modalService: NgbModal,
    public fb: FormBuilder,
    public ngWizardService: NgWizardService,
    public adminDataProvider: AdminDataProvider,
    public apiService: ApiService, public apiConfig: ApiConfiguration,
    public router: Router,
    private formBuilder: FormBuilder,
    public frequencyProviders: FrequencyProvider,
    private route: ActivatedRoute,
    private formateDate: DateFormateService,
    public regionProviders: RegionProvider,
    public unitsProviders: UnitsProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService,
    private toast: ToastClientService,
    private userRoles: RolesProvider,
    public alertService: AlertService,
    public activatedRoute: ActivatedRoute,
  ) {

    // this.uploadFile.currentMessage.subscribe(message => {
    //   if (message.status == 'success') {
    //     //this.showNextStep();
    //   }
    // })
  }





  ngOnInit() {
    /****Setting form********/
    this.addForm = this.formBuilder.group({
      target_title: ["", Validators.required],
      frequency_id: ["", Validators.required],
      start_date: ["", [Validators.required]],
      end_date: ["", [Validators.required]],
      target_description: [""],
      target_img: [""],
      announcement_image: [""],
      announcement: [""],
    });

    this._parameters = this.activatedRoute.params.subscribe((params) => {
      if (typeof params["id"] !== "undefined") {
        if (params["id"] !== "") {
          this.targetId = Number.parseInt(params["id"]);
          this.getMysteryTemplateConfig(this.targetId);
          //this.getAllMysteryCampaign();
          this.headerText = "Edit";
          //this.getAssignedUsers();
        }
      }
    });
  }


  ngDoCheck() {
    this.frequency = this.frequencyProviders.frequency;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.addForm.controls;
  }



  /* wizard section start */
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  isValidTypeBoolean: boolean = true;

  stepChanged(args: StepChangedArgs) {
    if (args.step.index == 0) {
      this.submittedLevels.state = "add target";
    } else if (args.step.index == 1) {
      this.submittedLevels.state = "userasign";
    } else if (args.step.index == 2) {
      this.submittedLevels.state = "addQuiz";
    } else if (args.step.index == 3) {
      this.submittedLevels.state = "message";
    }
    if (args.step.title == "Target & Point Sturcture") {
      // this.getAllApi(this.targetId);
      // this.getAllPointsStructure(this.targetId);
    }
    if (args.step.title == "Sales Achievements") {
      // this.getAllSaleAchievements(this.targetId);
    }
  }
  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }

  uploadImg(files, item) {
    let file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      let fileToUpload = reader.result;
      if (item == "banner") {
        this.targetModel.crown_target_img = fileToUpload;
      } else if (item == "announcement") {
        this.targetModel.announcement_image = fileToUpload;
      }
    };
  }

  getMysteryTemplateConfig(id) {
    this.apiService
      .getHeaders(this.apiConfig.getCrownTargetList + "?id=" + id)
      .subscribe(
        (res: any) => {
          this.targetModel = res.body.data as CrownTargetModel;
          this.targetModel.show = false;
          this.targetModel.statusString = (this.targetModel.status == 1) ? "Active" : "Inactive";
          if (new Date(this.targetModel.start_date) >= new Date()) {
            this.targetModel.show = true;
          }
          let dates = {
            start: this.targetModel.start_date.split("-"),
            end: this.targetModel.end_date.split("-"),
          };
          let startDate = {
            year: parseInt(dates.start[0]),
            month: parseInt(dates.start[1]),
            day: parseInt(dates.start[2]),
          };
          let endDate = {
            year: parseInt(dates.end[0]),
            month: parseInt(dates.end[1]),
            day: parseInt(dates.end[2]),
          };
          this.targetModel.startDate = startDate;
          this.targetModel.endDate = endDate;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  //

  onReset() {
    this.submitted = false;
    this.addForm.reset();
  }

  onSubmit() {
    this.submitted = true;
    // debugger;
    // stop here if form is invalid
    if (this.addForm.invalid) {
      return;
    }
    this.targetModel.start_date = this.formateDate.formateDate(this.targetModel.startDate);
    this.targetModel.end_date = this.formateDate.formateDate(this.targetModel.endDate);
    if (typeof this.targetId !== "undefined") {
      this.targetModel.id = this.targetId;
      this.updateTarget();
      this.addDates();
    } else {
      this.addTarget();
      this.addDates();
    }
    //this.addDates();
    this.showNextStep();
  }

  addDates() {
    let dates = {
      start: this.targetModel.start_date.split("-"),
      end: this.targetModel.end_date.split("-"),
    };
    let startDate = {
      year: parseInt(dates.start[0]),
      month: parseInt(dates.start[1]),
      day: parseInt(dates.start[2]),
    };
    let endDate = {
      year: parseInt(dates.end[0]),
      month: parseInt(dates.end[1]),
      day: parseInt(dates.end[2]),
    };
    this.targetModel.start_date = startDate;
    this.targetModel.end_date = startDate;
  }


  addTarget() {
    this.apiService
      .post(this.apiConfig.addCrownTarget, this.targetModel)
      .subscribe((res: any) => {
        if (res.body.status) {
          this.alertService.success(res.body.data.message);
          this.targetId = res.body.data.id;
          this.showNextStep();
        }
      });
  }

  updateTarget() {
    this.apiService
      .put(
        this.apiConfig.updateCrownTarget + "?id=" + this.targetModel.id,
        this.targetModel
      )
      .subscribe((res: any) => {
        if (res.status) {
          this.alertService.success(res.data.message);
          this.clearSuccess();
          this.showNextStep();
        }
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }


}
